import { PER_PAGE_OPTIONS, STATUS_OPTIONS, TRANSFER_OPTIONS } from 'domains/customer-refund-payment/constants/customer-refund-payment-constants'

const refundPaymentFilterFormFields = [
  {
    name    : 'status',
    label   : 'Status',
    type    : 'select',
    options : STATUS_OPTIONS
  },
  {
    name    : 'transfer_method',
    label   : 'Transfer method',
    type    : 'select',
    options : TRANSFER_OPTIONS
  },
  {
    name    : 'per_page',
    label   : 'Per-Page',
    type    : 'select',
    options : PER_PAGE_OPTIONS
  }
]

export default refundPaymentFilterFormFields
